import { render, staticRenderFns } from "./uploadCommonFile.vue?vue&type=template&id=143d633d&scoped=true&"
import script from "./uploadCommonFile.vue?vue&type=script&lang=js&"
export * from "./uploadCommonFile.vue?vue&type=script&lang=js&"
import style0 from "./uploadCommonFile.vue?vue&type=style&index=0&id=143d633d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143d633d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('143d633d')) {
      api.createRecord('143d633d', component.options)
    } else {
      api.reload('143d633d', component.options)
    }
    module.hot.accept("./uploadCommonFile.vue?vue&type=template&id=143d633d&scoped=true&", function () {
      api.rerender('143d633d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/uploadCommonFile.vue"
export default component.exports